import { SubjectId } from './types';

/** Areas of study each subject's question bank groups tags under, in display order. Mirrors backend/app/subjects.py. */
export const SUBJECT_AREAS: Record<SubjectId, readonly string[]> = {
  methods: ['Functions', 'Calculus', 'Probability'],
  specialist: ['Proofs', 'Functions', 'Complex Numbers', 'Calculus', 'Vectors', 'Probability'],
};

/** Short blurbs under Practice area cards. Methods stays compact (no descriptions). */
export const SUBJECT_AREA_DESCRIPTIONS: Partial<Record<SubjectId, Record<string, string>>> = {
  specialist: {
    Proofs: 'Logic, induction & proof techniques',
    Functions: 'Rational functions, partial fractions & graphs',
    'Complex Numbers': 'Polar form, De Moivre, roots & regions',
    Calculus: 'Differentiation, integration, DEs & kinematics',
    Vectors: '3D vectors, lines, planes & vector calculus',
    Probability: 'Linear combinations, sample means & hypothesis tests',
  },
};
